<div class="principal">
    <h1 class="textoPrincipal">Seja Bem vindo ao E-Transport !!!</h1>
    <h2 class="textoSec">Portal desenvolvido para acompanhamento do Fluxo de transportes.</h2>
    <!-- <img src="assets/Assinatura_500K.png" alt="Descrição da Imagem" class="imagemPrincipal"> -->
</div>